import React, { useEffect, useState } from "react";
import "./Technologies.css";

const Technologies = () => {
  const items = [
    {
      name: "HTML",
      category: "Frontend",
      desc: "Folosim HTML pentru a structura site-uri eficiente, bine optimizate și ușor de navigat.",
      img: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1726472858/RealCode/technologies/skill-icons_html_lurnjv.svg",
    },
    {
      name: "CSS",
      category: "Frontend",
      desc: "Stilizăm interfețele folosind CSS pentru a obține un design modern și o experiență vizuală impecabilă.",
      img: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1726472857/RealCode/technologies/skill-icons_css_b4cq9n.svg",
    },
    {
      name: "JavaScript",
      category: "Frontend / Backend",
      desc: "JavaScript ne permite să adăugăm funcționalități interactive și logici avansate în proiectele noastre.",
      img: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1726472858/RealCode/technologies/skill-icons_javascript_gtyi5f.svg",
    },
    {
      name: "React",
      category: "Frontend",
      desc: "Dezvoltăm aplicații web dinamice și scalabile cu React, folosind o arhitectură modulară pe componente.",
      img: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1726472859/RealCode/technologies/skill-icons_react-dark_eedhct.svg",
    },
    {
      name: "Firebase",
      category: "Backend",
      desc: "Integrăm Firebase pentru soluții rapide de backend, precum baze de date și autentificare în timp real.",
      img: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1726472857/RealCode/technologies/firebase_pwx8mn.svg",
    },
    {
      name: "AI",
      category: "Frontend / Backend",
      desc: "Folosim inteligență artificială pentru funcții smart precum recunoașterea imaginilor, automatizări și integrarea API-urilor.",
      img: "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1726472857/RealCode/technologies/ai.svg",
    },
  ];

  const [visibleItems, setVisibleItems] = useState(
    Array(items.length).fill(false)
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = entry.target.getAttribute("data-index");
          if (entry.isIntersecting) {
            setVisibleItems((prevState) =>
              prevState.map((isVisible, i) =>
                i === Number(index) ? true : isVisible
              )
            );
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll(".item");
    elements.forEach((element) => observer.observe(element));

    return () => {
      elements.forEach((element) => observer.unobserve(element));
    };
  }, []);

  return (
    <section className="technologies">
      <div className="sub-title">
        <h2 className="text-2">
          <span className="">Tehnologiile Folosite</span>
        </h2>
        {/* <p className="p-1">
          Acestea sunt tehnologiile pe care le folosim pentru a dezvolta
          site-uri performante, moderne și complet funcționale.
        </p> */}
      </div>
      <div className="items">
        {items.map((item, index) => (
          <div
            className={`item ${visibleItems[index] ? "visible" : ""}`}
            data-index={index}
            key={index}
          >
            <div>
              <img src={item.img} alt={item.name} />
              <div>
                <h3>{item.name}</h3>
                <p className="p-1">{item.category}</p>
              </div>
            </div>
            <hr />
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Technologies;
